<script>

export default {
    props: {
        search: {type: String, default: ''},
    },

    computed: {
        searchActive() {
            return this.searchInput != ''
        }
    },

    data() {
        return {
            searchInput: this.search,
        }
    },

    methods: {
        onSearchInput() {
            if (this.searchInput === '') this.$emit('delete-search')
        }
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg navbar-light bg-light">

  <div class="ms-auto">
    <form class="form-inline">
        <div class="d-flex flex-nowrap">
        <input class="form-control mx-2" type="search" placeholder="Quick Search" v-model="searchInput"
         v-on:keyup.enter="$emit('search', searchInput)" @input="onSearchInput()">
        <button class="btn btn-secondary me-2" @click.prevent="$emit('search', searchInput)">
            <span class="fa fa-search"></span>
        </button>
        </div>
    </form>
  </div>
</nav>
</template>